import React, { useEffect, useRef, useState } from "react";
import { Button, Card } from "react-bootstrap";
import "./PromptersCardMp.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
//import { fetchValueSellingCardRequest } from "../../../../../store/features/actions/opportunities/meetingPrepPromptersCardActions";
import { ValueSellingFrameworkPlaceholder } from "../../Opportunities/CardTabs/ValueSellingFramworkPlaceholder";
import { replaceUnderSquarebySpace } from "../../../../../services/commonService";
import iq_api_v2 from "../../../../../services/iqApiV2";
import * as FeatherIcon from "react-feather";
import { useUser } from "../../../../../context/UserContext";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import Alert from "../../../../HtmlElements/Alert";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import { fetchMeetingPrepPromptersCardRequest } from "../../../../../store/features/actions/meetingPrep/promptersCardActions";

export default function PromptersCardMp({ opportunityId }) {
  const fileInputRef = useRef(null);
  const { user } = useUser();
  const [apiSuccess, setApiSuccess] = useState("");
  const [apiError, setApiError] = useState("");
  const dispatch = useDispatch();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { clientName, accountName } = useParams();
  const { meetingPrepPromptersCardData, meetingPrepPromptersCardLoading, error } = useSelector(
    (state) => state?.meetingPrepPromptersCardReducer
  );

  const { getTaskStatus } = useTaskStatus();
  const taskStatus = getTaskStatus(
    `opp_sidecard_value_selling_prompter_${opportunityId}`
  );

  useEffect(() => {
    console.log("taskStatus", taskStatus);
    if (taskStatus == "completed") {
      if (opportunityId) {
        dispatch(fetchMeetingPrepPromptersCardRequest({ opportunityId }));
      }
    }
  }, [taskStatus]);

  useEffect(() => {
    if (opportunityId) {
      dispatch(fetchMeetingPrepPromptersCardRequest({ opportunityId }));
    }
  }, [opportunityId]);

  useEffect(() => {
    if (meetingPrepPromptersCardData) {
      delete meetingPrepPromptersCardData?._id;
      delete meetingPrepPromptersCardData?.opportunity_id;

      setResult(meetingPrepPromptersCardData || []);
      setStatus("Completed!");
    } else if (error) {
      setStatus("Error loading data");
    }
  }, [meetingPrepPromptersCardData, error]);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    setResult(null);

    const files = event.target.files;
    if (files.length === 0) return;

    const formData = new FormData();

    // Append files
    for (let file of files) {
      formData.append("file", file);
      formData.append("document_type", "meeting_summary");
    }

    // Append extra parameters
    formData.append("user_id", user.id);
    formData.append("opportunity_id", opportunityId);

    try {
      const upload_response = await iq_api_v2.post(
        "/opportunities/get_value_selling_prompter_2",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const success =
        upload_response?.status === 200 || upload_response?.status === 201
          ? true
          : false;

      if (success === true) {
        // fetchFiles();

        setApiSuccess("File uploaded successfully..!");
        setTimeout(() => {
          dispatch(fetchMeetingPrepPromptersCardRequest({ opportunityId }));
          setApiSuccess("");
        }, 5000);
      } else {
        setApiError("Unable to upload the file. Please try again.");
        setTimeout(() => {
          setApiError("");
        }, 5000);
      }

      // Optionally show success message
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls outside the range of 2xx
        if (error.response.status === 400) {
          setApiError(
            "Unable to upload the file: " + error?.response?.data?.detail
          );
          // setTimeout(() => { setApiError(""); }, 5000);
        } else {
          setApiError("Unexpected error:" + error?.response?.data);
          setTimeout(() => {
            setApiError("");
          }, 5000);
        }
      } else if (error.request) {
        // The request was made but no response was received
        setApiError("No response received:" + error?.request);
        setTimeout(() => {
          setApiError("");
        }, 5000);
      } else {
        // Something happened in setting up the request
        setApiError("Request error:" + error?.message);
        setTimeout(() => {
          setApiError("");
        }, 5000);
      }
    }
  };

  if (taskStatus == "pending" && taskStatus != "failed") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GeneratingLoader />
      </div>
    );
  }

  const displayCardData = (key, dataArr) => {
    return <div className="col-md-12" key={key}>
        <div className="battle_card_block">
          <Card className="battle_card_custom">
            <Card.Header
              className={`battle_card_header ${
                dataArr?.[0].classification == "Weak Answer"
                  ? "negative"
                  : ""
              }`}
            >
              <span>{replaceUnderSquarebySpace(key)} </span>

              {dataArr?.[0].classification &&
                dataArr?.[0].classification != "No Answer" && (
                  <span
                    className={`${
                      dataArr?.[0].classification ==
                      "Strong Answer"
                        ? "positive_text"
                        : "negative_text"
                    } `}
                  >
                    {dataArr[0].classification}
                  </span>
                )}
            </Card.Header>
            <Card.Body className="battle_card_body">
              <div className="battle_content_block">
                <div className="row">
                  {Object.entries(dataArr || {}).map(
                    ([key_2, rowVal]) => (
                      <div
                        className="col-md-12 pr-0 pl-0"
                        key={key_2}
                      >
                        <div className="right_battle_content_block">
                          <p className="right_battle_content">
                            <div className="row">
                              <div className="col-md-2 pr-0">
                                {" "}
                                <strong>
                                  Q {parseInt(key_2) + 1}:
                                </strong>{" "}
                              </div>
                              <div className="col-md-10">
                                {rowVal?.question}{" "}
                              </div>
                            </div>

                            {rowVal?.answer && (
                              <div className="row mb-3">
                                <div className="col-md-2 pr-0">
                                  {" "}
                                  <strong>
                                    A. {parseInt(key_2) + 1}:
                                  </strong>{" "}
                                </div>
                                <div className="col-md-10">
                                  {rowVal?.answer ==
                                  "No answer" ? (
                                    <span>
                                      {" "}
                                      <strong>No Answer</strong>
                                    </span>
                                  ) : (
                                    <>{rowVal?.answer}</>
                                  )}
                                </div>
                              </div>
                            )}
                          </p>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
  }

  return (
    <div className="value_selling_wrapper">
      {apiSuccess && (
        <Alert
          type="success"
          style={{ textAlign: "left" }}
          message={apiSuccess}
        />
      )}
      {apiError && (
        <Alert type="danger" style={{ textAlign: "left" }} message={apiError} />
      )}

      <div className="container">
        <div className="row">
          {meetingPrepPromptersCardLoading === true ? (
            <>
              <ValueSellingFrameworkPlaceholder numberOfCards={10} />
            </>
          ) : Object.keys(result||{}).length === 0 ? (
            <div className="no-data-message">
              <NoDataComp
                message="Content is being generated"
                buttonText="Refresh"
                onButtonClick={() =>
                  dispatch(fetchMeetingPrepPromptersCardRequest({ opportunityId }))
                }
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <div className="row mb-2">
                  <div className="col-md-12 align-right">
                    <Button className="btn_upload" onClick={handleUploadClick}>
                      <FeatherIcon.Upload className="upload_icon" />
                      Upload Meeting Summary
                    </Button>

                    <input
                      type="file"
                      accept=".doc,.docx,.ppt,.pptx,.pdf,.txt"
                      multiple
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="row">

                  <div className="col-md-6">
                    <div className="row">
                    {
                  Object.entries(result || {}).filter((_, index) => index % 2 === 0).map(([key, dataArr]) => (
                    <>{displayCardData(key, dataArr)}</>
                  ))}
                    </div>
                  </div>


                  <div className="col-md-6">
                    <div className="row">
                    {
                  Object.entries(result || {}).filter((_, index) => index % 2 !== 0).map(([key, dataArr]) => (
                    <>{displayCardData(key, dataArr)}</>
                  ))}
                    </div>
                  </div>





                  

                  
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
